/*
 * @Description: 
 * @Author: Chen Bi Qi
 * @Date: 2020-09-15 22:57:49
 * @LastEditTime: 2021-02-06 15:36:50
 */
import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import util from "@/utils/util";
import {
  message
} from 'ant-design-vue';
import {
  getMe,
} from "@/request/api";

Vue.use(Vuex)

const ADD_COUNT = 'ADD_COUNT'; // 用常量代替事件类型，使得代码更清晰
const REMOVE_COUNT = 'REMOVE_COUNT';
export default new Vuex.Store({
  state: {
    token: '',
    isAdmin: null,
    canteen: {},
    canteenConfig: {},
    useRouter: localStorage.getItem("useRouter") == null ? [] : JSON.parse(localStorage.getItem("useRouter")),
    useAuth: [],
    collapsed:true,
    selectedKeys:[]
  },
  mutations: {
    //写法与getters相类似
    //组件想要对于vuex 中的数据进行的处理
    //组件中采用this.$store.commit('方法名') 的方式调用，实现充分解耦
    //内部操作必须在此刻完成(同步)
    [ADD_COUNT] (state, token) { // 第一个参数为 state 用于变更状态 登录
      localStorage.setItem("token", token);
      state.token = token;
    },
    // 更新选中的权限菜单栏
    UPDATE_SELECTEDKEYS(state, path){
      // console.log(router.app._route.path)
      // console.log(router)
      state.selectedKeys = path
    },

    REMOVE_COUNT (state) { // 退出登录
      localStorage.removeItem("token");
      state.token = ""
      router.push({
        path: "/login"
      });
      message.success('退出成功！');
    },

    /**
     * @description: 获取账户，是否管理员
     * @param {type} 
     * @return {type} 
     */
    SET_ADMIN (state, data) {
      state.staff = data
    },

    SET_CANTEEN (state, data) {
      state.canteen = data
    },

    SET_CANTEEN_CONFIG (state, data) {
      state.canteenConfig = data
    },
    SET_PERMISSIONS (state, data) {
      state.permissions = data
    },
    // 左侧导航栏伸展状态更改
    CHANGE_COLLAPSED(state){
      state.collapsed = !state.collapsed
    },

    //左侧导航栏伸展状态更改为收
    CHANGE_COLLAPSED_TRUE(state){
      state.collapsed = true
    },

  },
  actions: {

    GET_ME ({ }, data) {
      // console.log(data)
      return new Promise((resolve, reject) => {
        getMe(data).then(res => {
          resolve(res.data.result.staff)
          this.commit('SET_ADMIN', res.data.result.staff)
          this.commit('SET_CANTEEN', res.data.result.canteen)
          this.commit('SET_CANTEEN_CONFIG', res.data.result.config)
          this.commit('SET_PERMISSIONS', res.data.result.permissions)
        }).catch(err => {
          reject(err)
        })
      })
    }

  },
  modules: {}
})